import apiClient from '../core/apiClient';

export async function createImageGenerationRequest(payload) {
  const response = await apiClient.post('/image-generation/requests', payload);
  return response.data;
}

export async function getImageGenerationJobs() {
  const response = await apiClient.get('/image-generation/jobs');
  return response.data.jobs;
}

export async function getImageGenerationRequests() {
  const response = await apiClient.get('/image-generation/requests');
  return response.data.requests;
}
